<template>
  <div class="pa-4 position-relative">
    <v-card outlined class="rounded-lg pa-6">
      <!-- لودینگ اتمی -->
      <v-overlay :value="fetchingData" absolute opacity="0.4" color="white" z-index="2">
        <atom-spinner
          :animation-duration="1500"
          :size="80"
          class="mx-auto"
          color="indigo"
        />
      </v-overlay>

      <h3 class="mb-4">کسر قیمت رقبا ({{ marketplaceTitle }})</h3>
      <p class="text-caption grey--text text--darken-1">
        درصدی که می‌خواهید از مبلغ رقبا کسر شود را وارد کنید.
      </p>

      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.competitor_deduction_percent"
              label="درصد کسر"
              type="number"
              step="0.01"
              outlined
              dense
              suffix="%"
              min="0"
              max="100"
              hide-details="auto"
              :rules="[
                v => (v !== null && v !== '' && v !== undefined) || 'وارد کردن درصد الزامی است',
                v => (Number(v) >= 0 && Number(v) <= 100) || 'درصد باید بین ۰ تا ۱۰۰ باشد'
              ]"
              class="rounded-lg"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>

      <v-btn
        class="btn-get-code rounded-lg px-6 mt-6"
        :loading="loading"
        :disabled="!valid || fetchingData"
        @click="saveSettings"
      >
        <v-icon left>mdi-content-save</v-icon>
        ذخیره تنظیمات
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";

export default {
  name: "CompetitorDeductionTab",
  components: {
    AtomSpinner,
  },
  props: {
    marketplace: {
      type: String,
      default: "digikala",
    },
    store_id: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    fetchingData: false,
    form: {
      product_id: null,
      store_id: null,
      min_unit_price: 0,
      max_unit_price: 0,
      competitor_deduction_percent: 0,
      is_active: true,
      profit_percent: 0,
      profit_target_price: "min",
      commission_percent: 15.0,
      tax_percent: 10.0,
      processing_fee_percent: 7,
      processing_fee_min: 360000,
      processing_fee_max: 2400000,
      lead_time: 1,
      seller_lead_time: 2,
    },
  }),

  computed: {
    marketplaceTitle() {
      const titles = {
        digikala: "دیجی‌کالا",
        woocommerce: "ووکامرس",
        divar: "دیوار",
        physical_store: "فروشگاه فیزیکی",
        technolife: "تکنولایف",
        snappshop: "اسنپ‌شاپ",
      };
      return titles[this.marketplace] || this.marketplace;
    },
    // مارکت‌هایی که قیمت‌گذاری هوشمند/کسر رقبا برای آن‌ها در این API فعال است
    isMarketplaceEligible() {
      const eligible = ["digikala", "woocommerce", "snappshop", "technolife", "general_settings"];
      return eligible.includes(this.marketplace);
    },
  },

  watch: {
    marketplace: {
      immediate: true,
      handler() {
        this.fetchPricingSettings();
      },
    },
  },

  methods: {
    async fetchPricingSettings() {
      if (!this.isMarketplaceEligible) {
        return;
      }

      this.fetchingData = true;
      try {
        const response = await this.$api.get("/v1/marketplace/pricing-settings",{params:{
          store_id:this.store_id
        }});
        const data = response.data?.data || response.data?.result || response.data||[];

        if (data && typeof data === "object") {
          this.form = {
            ...this.form,
            ...data,
            product_id: null,
            store_id: null,
            min_unit_price: data.min_unit_price !== undefined ? Number(data.min_unit_price) : 0,
            max_unit_price: data.max_unit_price !== undefined ? Number(data.max_unit_price) : 0,
            competitor_deduction_percent:
              data.competitor_deduction_percent !== undefined && data.competitor_deduction_percent !== null
                ? Number(data.competitor_deduction_percent)
                : 0,
          };
        }
      } catch (error) {
        console.error("خطا در دریافت تنظیمات:", error);
      } finally {
        this.fetchingData = false;
      }
    },

    async saveSettings() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      const payload = {
        product_id: null,
        store_id: null,
        min_unit_price: Number(this.form.min_unit_price || 0),
        max_unit_price: Number(this.form.max_unit_price || 0),
        competitor_deduction_percent: Number(this.form.competitor_deduction_percent || 0),
        is_active: Boolean(this.form.is_active),
        profit_percent: Number(this.form.profit_percent || 0),
        profit_target_price: this.form.profit_target_price || "min",
        commission_percent: Number(this.form.commission_percent || 15),
        tax_percent: Number(this.form.tax_percent || 10),
        processing_fee_percent: Number(this.form.processing_fee_percent || 7),
        processing_fee_min: Number(this.form.processing_fee_min || 360000),
        processing_fee_max: Number(this.form.processing_fee_max || 2400000),
        lead_time: Number(this.form.lead_time || 1),
        seller_lead_time: Number(this.form.seller_lead_time || 2),
        store_id: this.store_id||null
      };

      try {
        await this.$api.post("/v1/marketplace/pricing-settings", payload);
        this.$toast.success("تنظیمات با موفقیت ذخیره شد.");
        this.$emit("saved");
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "خطا در ذخیره تنظیمات");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
